// extracted by mini-css-extract-plugin
export var completionBody = "_ly-2";
export var completionCard = "_ly-0";
export var completionFooter = "_ly-3";
export var completionTitle = "_ly-1";